<template>
  <cube-page title="省区分析"
             @back="back">
    <div slot="content">
      <!-- <button @click="exportLayout">获取布局</button> -->
      <div v-if="ddiDate && monthDate"
           class="date">
        <span class="text">销售发出:{{ ddiDate.format("YYYY.MM.DD") }}</span>
        <span class="text">商业流向:{{ ddiDate.format("YYYY.MM.DD") }}</span>
        <span class="text">连锁流向:{{ monthDate.format("YYYY.MM.DD") }}</span>
      </div>
      <div class="filter-bar flex-wrap flex-none">
        <cube-select class="area-select"
                     v-model="province"
                     :options="provinceOptions"
                     placeholder="请选择省份"
                     ref="areaPicker"
                     @change="changeHandle">
        </cube-select>
      </div>
      <wmq-layout class="layout"
                  v-if="configData"
                  style="margin: 10px"
                  ref="mainDashboard"
                  :rootLayoutConfig="configData">
      </wmq-layout>
      <el-tabs v-model="currentBrand"
               @tab-click="handleBrandClick"
               style="margin: 15px"
               :stretch="true">
        <el-tab-pane v-for="item in brandList"
                     :label="item.name"
                     :name="item.name"
                     :key="item.name">
          <wmq-layout v-if="currentBrand === item.name"
                      class="layout"
                      style="margin: 10px"
                      :ref="item.name"
                      :rootLayoutConfig="brandConfig[item.name]">
          </wmq-layout>
        </el-tab-pane>
      </el-tabs>
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/province-analyse-ui-config'
import longmu60UiConfig from '@/config/ui-config/province-analyse-ui-config-longmu-60'
import longmu30UiConfig from '@/config/ui-config/province-analyse-ui-config-longmu-30'
import otherBrandUiConfig from '@/config/ui-config/province-analyse-ui-config-other-brand'
import apiCacheHandle from '@/utils/apiCache'
import { biData } from '@/api/cube'
import { getGeography } from '@/api/area'
import { CubeDataHandle } from 'wmq-component'
import { getFlowTime } from '@/api/bigCustomer'
import { get, has, isEmpty, set, replace } from 'lodash'
import { mapGetters } from 'vuex'
import DateUtils from '@/utils/date'
import CubePage from '../../components/cube-page'
import moment from 'moment'
export default {
  name: 'ProvinceAnalyse',
  components: { CubePage },
  data () {
    return {
      province: '',
      rollbackSixMonthArr: undefined,
      ddiDate: undefined,
      monthDate: undefined,
      lastDdiYearMonthArr: undefined,
      ddiMonthArr: undefined,
      areaData: undefined,
      lastYearDate: undefined,
      channelTypeQuery: ['龙牡60总部', '龙牡60门店'],
      isClearCache: false,
      channelType: '龙牡60',
      configData: undefined,
      currentBrand: undefined,
      brandList: [
        {
          name: '60袋龙牡'
        },
        {
          name: '30袋龙牡'
        },
        {
          name: '108粒便通'
        },
        {
          name: '48粒便通'
        },
        {
          name: '24粒便通'
        },
        {
          name: '45片咽喉片'
        },
        {
          name: '24片咽喉片'
        },
        {
          name: '16片咽喉片'
        }
      ],
      longmu60UiConfig,
      longmu30UiConfig,
      otherBrandUiConfig
    }
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        let dataCodes = data.dataCode
        if (dataCodes instanceof Array) {
          const apiArr = []
          const monthList = [
            '龙牡60标题',
            '龙牡60总部覆盖',
            '龙牡60门店覆盖',
            '协议连锁标题',
            '协议连锁覆盖',
            '协议连锁门店覆盖',
            '非协议连锁标题',
            '非协议连锁覆盖',
            '单体药店标题',
            '单体药店覆盖',
            '终端覆盖标题',
            '终端覆盖'
          ]
          const ddiList = [
            '黄金单品标题',
            '销售公司标题',
            '铺货',
            '达标',
            '龙牡60门店铺货标题',
            '单体药店铺货标题',
            '协议连锁门店铺货标题',
            '龙牡60门店达标标题',
            '单体药店达标标题',
            '协议连锁门店达标标题'
          ]
          dataCodes.forEach((code) => {
            const orgReq = get(reqObj, code, {})
            const req = that.handleCodeQuery(code, orgReq)
            if (ddiList.indexOf(code) > -1) {
              apiArr.push(
                new Promise((resolve) => {
                  resolve({
                    data: {
                      subTitle:
                        that.ddiDate.format('YYYY') +
                        '-01-01' +
                        '至' +
                        that.ddiDate.format(
                          'YYYY-MM-DD'
                        )
                    }
                  })
                })
              )
            } else if (monthList.indexOf(code) > -1) {
              apiArr.push(
                new Promise((resolve) => {
                  resolve({
                    data: {
                      subTitle:
                        that.rollbackSixMonthArr[5] +
                        '-01' +
                        '至' +
                        that.monthDate.format(
                          'YYYY-MM-DD'
                        )
                    }
                  })
                })
              )
            } else if (code === '健民发出标题') {
              apiArr.push(
                new Promise((resolve) => {
                  resolve({
                    data: {
                      subTitle:
                        that.ddiDate.format('YYYY-MM') +
                        '-01' +
                        '至' +
                        that.ddiDate.format(
                          'YYYY-MM-DD'
                        )
                    }
                  })
                })
              )
            } else {
              apiArr.push(
                apiCacheHandle(
                  biData,
                  that.pageKey,
                  (argArray) => {
                    return (
                      'bidata.' +
                      argArray[0] +
                      '.' +
                      JSON.stringify(req)
                    )
                  },
                  true,
                  that
                )(code, req)
              )
            }
          })
          return Promise.all(apiArr).then((res) => {
            const result = {}
            for (let i = 0; i < res.length; i++) {
              if (dataCodes[i] === 'provinceMapCoverCity') {
                res[i] = JSON.parse(
                  JSON.stringify(res[i]).replace(
                    /district/g,
                    'city'
                  )
                )
                dataCodes[i] = 'provinceMapCover'
              }
              if (dataCodes[i] === 'provinceMapCover') {
                // TODO: 需优化
                if (that.province === '海南省') {
                  that.areaData.features =
                    that.areaData.features.filter(
                      (item) =>
                        item.properties.name !==
                        '三沙市'
                    )
                }
                res[i].data.data = res[i].data.data.filter(
                  (item) => item.city !== '省直辖县级行政区划'
                )
                res[i].data.mapData = that.areaData
              }
              result[dataCodes[i]] =
                CubeDataHandle.handleCubeData(res[i].data)
            }
            return new Promise((resolve) => {
              resolve(result)
            })
          })
        } else {
          if (
            dataCodes === '协议连锁标题' ||
            dataCodes === '龙牡60标题' ||
            dataCodes === '非协议连锁标题' ||
            dataCodes === '单体药店标题' ||
            ''
          ) {
            return new Promise((resolve) => {
              resolve({})
            })
          }
          reqObj = that.handleCodeQuery(dataCodes, reqObj)
          data.queryParams = {
            ...data.queryParams,
            ...reqObj
          }
          return apiCacheHandle(
            biData,
            that.pageKey,
            (argArray) => {
              return (
                'bidata.' +
                argArray[0] +
                '.' +
                JSON.stringify(reqObj)
              )
            },
            true,
            that
          )(dataCodes, reqObj).then((res) => {
            if (dataCodes === 'provinceMapCoverCity') {
              res = JSON.parse(
                JSON.stringify(res).replace(/district/g, 'city')
              )
              dataCodes = 'provinceMapCover'
            }
            if (dataCodes === 'provinceMapCover') {
              // TODO: 需优化
              if (that.province === '海南省') {
                that.areaData.features =
                  that.areaData.features.filter(
                    (item) =>
                      item.properties.name !== '三沙市'
                  )
              }
              res.data.data = res.data.data.filter(
                (item) => item.city !== '省直辖县级行政区划'
              )
              res.data.mapData = that.areaData
            }

            return new Promise((resolve) => {
              resolve(CubeDataHandle.handleCubeData(res.data))
            })
          })
        }
      }
    }
  },
  mounted () {
    apiCacheHandle(
      getFlowTime,
      this.pageKey,
      () => {
        return 'flowTime'
      },
      true,
      this
    )().then((res) => {
      this.ddiDate = moment(res.data.ddiMaxDay || res.data.monthMaxDay)
      this.monthDate = moment(res.data.monthMaxDay)
      this.lastYearDate = moment(
        res.data.ddiMaxDay || res.data.monthMaxDay
      ).subtract(1, 'years')
      this.lastDdiYearMonthArr = DateUtils.getMonthArr(
        this.lastYearDate.format('YYYY-MM'),
        -(this.lastYearDate.get('month') + 1)
      ).map((item) => item.format('YYYY-MM'))
      this.rollbackSixMonthArr = DateUtils.getMonthArr(
        this.monthDate.format('YYYY-MM'),
        -6
      ).map((item) => item.format('YYYY-MM'))
      this.ddiMonthArr = DateUtils.getMonthArr(
        this.ddiDate.format('YYYY-MM'),
        -(this.ddiDate.get('month') + 1)
      ).map((item) => item.format('YYYY-MM'))
      this.$store
        .dispatch('GetCacheInfo', {
          pageKey: this.pageKey,
          apiKey: 'page'
        })
        .then((page) => {
          this.province = get(
            page,
            'province',
            this.provinceOptions[0].value
          )
          this.channelType = get(page, 'channelType', '龙牡60')
          this.configData = this.getConfigData()
          this.currentBrand = this.currentBrand = get(
            page,
            'currentBrand',
            '60袋龙牡'
          )
          const that = this
          this.$nextTick(() => {
            this.changeHandle(this.province)
            setTimeout(() => {
              document.getElementsByClassName(
                'content'
              )[0].scrollTop = get(page, 'top', 0)
            }, 100)
            this.$refs.mainDashboard.dataEventBus.$on(
              'mapTabChange',
              function (msg, channelTypeVue) {
                const channelType =
                  channelTypeVue.$options.propsData.label
                let channelTypeQuery
                if (channelType === '龙牡60') {
                  channelTypeQuery = [
                    '龙牡60总部',
                    '龙牡60门店'
                  ]
                } else if (channelType === '协议连锁') {
                  channelTypeQuery = [
                    '协议连锁',
                    '协议连锁门店'
                  ]
                } else if (channelType === '非协议连锁') {
                  channelTypeQuery = ['非协议连锁']
                }
                that.channelTypeQuery = channelTypeQuery
                that.channelType = channelType
                that.$store.commit('CLEAR_CACHE_INFO_API', {
                  pageKey: that.pageKey,
                  apiKey: 'bidata.provinceMapCover'
                })
                that.$refs.mainDashboard.refreshByKey(
                  '终端覆盖'
                )
              }
            )
          })
        })
    })
  },
  computed: {
    ...mapGetters(['provinceList']),
    provinceOptions () {
      const options = []
      this.provinceList.forEach((item) => {
        options.push({
          text: item.name,
          value: item.name
        })
      })
      return options
    },
    pageKey () {
      return this.$route.name
    },
    brandConfig () {
      const config = {}
      this.brandList.forEach((item) => {
        if (item.name === '60袋龙牡') {
          config[item.name] = this.longmu60UiConfig
        } else if (item.name === '30袋龙牡') {
          config[item.name] = this.longmu30UiConfig
        } else {
          config[item.name] = { ...this.otherBrandUiConfig }
        }
      })
      return config
    }
  },
  beforeRouteLeave (to, from, next) {
    if (
      ['productCoverByCity', 'regionalDistribution'].indexOf(to.name) > -1
    ) {
      this.$store.commit('SET_CACHE_INFO', {
        pageKey: this.pageKey,
        apiKey: 'page.province',
        data: this.province
      })
      this.$store.commit('SET_CACHE_INFO', {
        pageKey: this.pageKey,
        apiKey: 'page.channelType',
        data: this.channelType
      })
      this.$store.commit('SET_CACHE_INFO', {
        pageKey: this.pageKey,
        apiKey: 'page.top',
        data: document.getElementsByClassName('content')[0].scrollTop
      })
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (
        ['productCoverByCity', 'regionalDistribution'].indexOf(
          from.name
        ) === -1
      ) {
        vm.$store.commit('CLEAR_CACHE_INFO', vm.pageKey)
      }
    })
  },
  methods: {
    handleCodeQuery (dataCode, reqObj) {
      reqObj.province = this.province
      if (dataCode === 'provinceMapCover') {
        reqObj.channelType = this.channelTypeQuery
      }
      const productCover = [
        'product60headquartersNumber',
        'product60headquartersPercent',
        'product60storesNumber',
        'product60storesPercent',
        'product60headquartersCoverList',
        'product60storesCoverList',
        'product30controllableHeadquartersNumber',
        'product30controllableHeadquartersPercent',
        'product30controllableStoresNumber',
        'product30controllableStoresPercent',
        'product30controllableHeadquartersCoverList',
        'product30controllableStoresCoverList',
        'product30notControllableHeadquartersNumber',
        'product30notControllableHeadquartersPercent',
        'product30notControllableHeadquartersCoverList',
        'product30storeHeadquartersNumber',
        'product30storeHeadquartersPercent',
        'product30storeHeadquartersCoverList',
        'provinceMapCover',
        '协议连锁标题',
        '龙牡60标题',
        '非协议连锁标题',
        '单体药店标题'
      ]
      const distributionStandards = [
        'distributionIndicators',
        'standardsIndicators',
        'product60storesDistributionIndicatorsPercent',
        'product60storesDistributionIndicatorsNum',
        'product30notControllableStoresDistributionIndicatorsNum',
        'product30notControllableStoresDistributionIndicatorsPercent',
        'product30controllableStoresDistributionIndicatorsPercent',
        'product30controllableStoresDistributionIndicatorsNum',
        'product60storesStandardsIndicatorsPercent',
        'product60storesStandardsIndicatorsNum',
        'product30notControllableStoresStandardsIndicatorsPercent',
        'product30notControllableStoresStandardsIndicatorsNum',
        'product30controllableStoresStandardsIndicatorsPercent',
        'product30controllableStoresStandardsIndicatorsNum'
      ]
      if (distributionStandards.indexOf(dataCode) > -1) {
        reqObj.year = this.ddiDate.format('YYYY')
      }
      if (productCover.indexOf(dataCode) > -1) {
        reqObj.month = this.rollbackSixMonthArr
      }
      if (dataCode === 'productList2022') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }
      if (dataCode === 'productList2021') {
        reqObj.date = this.lastYearDate.format('YYYY-MM-DD')
      }
      if (dataCode === 'productPercent') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }
      // TODO: 在列表得页面当中 508行赋值已经可以了，此次赋值调查得结果是在详情里面会把req 传到详情中 故而代码不能删除掉
      if (has(reqObj, 'month') && isEmpty(get(reqObj, 'month'))) {
        reqObj.month = this.ddiDate.format('YYYY-MM')
      }
      // TODO: dateFlag === '__date__' 由于has(reqObj, 'date') 为false 导致json里的date 为空 过滤异常 添加一个Flag
      if (get(reqObj, 'date') === '__date__') {
        reqObj.date = this.ddiDate.format('YYYY-MM-DD')
      }

      if (has(reqObj, 'year') && isEmpty(get(reqObj, 'year'))) {
        reqObj.year = this.ddiDate.format('YYYY')
      }
      if (
        (this.province === '北京市' ||
          this.province === '重庆市' ||
          this.province === '上海市' ||
          this.province === '天津市') &&
        dataCode === 'provinceMapCover'
      ) {
        reqObj.city = this.province
        delete reqObj.province
        // delete data.queryParams.province
        dataCode = dataCode + 'City'
      } else {
        reqObj.province = this.province
        delete reqObj.city
        // delete data.queryParams.city
      }
      if (has(reqObj, 'productBrand')) {
        reqObj.productBrand = this.currentBrand
      }
      return reqObj
    },
    getConfigData () {
      set(uiConfig, 'schema.0.children.ka产品.props.options.conditions', {
        text: [
          {
            field: 'monthAmount_LINK',
            mapping: this.filedMap
          },
          {
            field: 'yearAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      set(
        uiConfig,
        'schema.0.children.商务产品.props.options.conditions',
        {
          text: [
            {
              field: 'monthAmount_LINK',
              mapping: this.filedMap
            },
            {
              field: 'yearAmount_YOY_R',
              mapping: this.filedMap
            }
          ]
        }
      )
      set(
        uiConfig,
        'schema.0.children.招商产品.props.options.conditions',
        {
          text: [
            {
              field: 'monthAmount_LINK',
              mapping: this.filedMap
            },
            {
              field: 'yearAmount_YOY_R',
              mapping: this.filedMap
            }
          ]
        }
      )
      set(
        uiConfig,
        'schema.0.children.黄金单品表格.props.options.conditions',
        {
          text: [
            {
              field: 'salesAmount_LINK',
              mapping: this.filedMap
            },
            {
              field: 'yearAmount_YOY_R',
              mapping: this.filedMap
            }
          ]
        }
      )
      let templateHtml = get(
        uiConfig,
        'schema.0.children.终端覆盖.props.children.0.终端覆盖标题.props.toolbar.templateHtml'
      )
      templateHtml = replace(
        templateHtml,
        new RegExp('[v][a][l][u][e][=]["]\\S*["]'),
        'value="' + this.channelType + '"'
      )
      set(
        uiConfig,
        'schema.0.children.终端覆盖.props.children.0.终端覆盖标题.props.toolbar.templateHtml',
        templateHtml
      )
      return uiConfig
    },
    exportLayout () {
      const layoutConfig = this.$refs.mainDashboard.extractLayoutConfig()
      window.prompt('布局信息', JSON.stringify(layoutConfig))
    },
    filedMap (fieldValue) {
      if (fieldValue && fieldValue.indexOf('-') > -1) {
        return {
          fill: 'red'
        }
      }
      return { fill: '#333333' }
    },
    back () {
      this.$store.commit('CLEAR_CACHE_INFO', this.pageKey)
    },
    changeHandle (value) {
      const areaCode = this.provinceList.filter(
        (province) => province.name === value
      )[0].code
      this.$store.commit('CLEAR_CACHE_INFO_API', {
        pageKey: this.pageKey,
        apiKey: 'getGeography'
      })
      apiCacheHandle(
        getGeography,
        this.pageKey,
        () => {
          return 'getGeography'
        },
        true,
        this
      )(areaCode, 2020, 'full').then((areaRes) => {
        this.areaData = areaRes
        if (this.isClearCache) {
          this.$store.commit('CLEAR_CACHE_INFO_API', {
            pageKey: this.pageKey,
            apiKey: 'bidata'
          })
        }
        this.isClearCache = true
        this.$refs.mainDashboard.refreshAll()
        this.brandRefreshAll()
      })
    },
    handleBrandClick () {
      this.$store.commit('SET_CACHE_INFO', {
        pageKey: this.pageKey,
        apiKey: 'page.currentBrand',
        data: this.currentBrand
      })
      const scrollTop =
        document.getElementsByClassName('content')[0].scrollTop
      this.$nextTick(() => {
        this.brandRefreshAll()
        setTimeout(() => {
          document.getElementsByClassName('content')[0].scrollTop =
            scrollTop
        }, 5)
      })
    },
    brandRefreshAll () {
      this.$refs[this.currentBrand][0].refreshAll()
    }
  }
}
</script>
<style scoped lang="stylus">
.date
  font-size 18px
  color #666666
  padding 30px 30px 0px 30px
  .text
    margin 0px 10px
.area-select
  width 100%
  margin 20px
.vue-grid-layout
  background #fff !important
</style>
<style lang="stylus">
.chart-open-link
  font-size 14PX
  color #5785ea
  padding-left 28px
  font-weight normal
  display flex
.tab
  float right
  height 50px
  margin-top -25px
  .el-tabs__item
    font-size 20px !important
    padding 0px 10px !important
    height 30px
.cube-picker-panel .cube-picker-content .cube-picker-wheel-wrapper >div:only-child
  width 100% !important
.layout .el-progress-bar__innerText
  color #000 !important
</style>
